<template>
    <div class="custom-fields-list">
        <template v-for="customField in customFields">
            <CustomFieldSimpleText
                v-if="customField.type === CUSTOM_FIELDS_TYPES.SIMPLE_TEXT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldRichText
                v-if="customField.type === CUSTOM_FIELDS_TYPES.RICH_TEXT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldNumeric
                v-if="customField.type === CUSTOM_FIELDS_TYPES.NUMERIC"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldAmountWithCurrency
                v-if="customField.type === CUSTOM_FIELDS_TYPES.AMOUNT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldNumericWithUnit
                v-if="customField.type === CUSTOM_FIELDS_TYPES.NUMERIC_WITH_UNIT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldRadio
                v-if="customField.type === CUSTOM_FIELDS_TYPES.RADIO"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldSelect
                v-if="customField.type === CUSTOM_FIELDS_TYPES.SELECT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldBoolean
                v-if="customField.type === CUSTOM_FIELDS_TYPES.BOOLEAN"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldDate
                v-if="customField.type === CUSTOM_FIELDS_TYPES.DATE"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldTime
                v-if="customField.type === CUSTOM_FIELDS_TYPES.TIME"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldEmail
                v-if="customField.type === CUSTOM_FIELDS_TYPES.EMAIL"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldCheckBox
                v-if="customField.type === CUSTOM_FIELDS_TYPES.CHECKBOX"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldThird
                v-if="customField.type === CUSTOM_FIELDS_TYPES.THIRD"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldURL
                v-if="customField.type === CUSTOM_FIELDS_TYPES.URL"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldItem
                v-if="customField.type === CUSTOM_FIELDS_TYPES.ITEM"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldContact
                v-if="customField.type === CUSTOM_FIELDS_TYPES.CONTACT"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
            <CustomFieldStaff
                v-if="customField.type === CUSTOM_FIELDS_TYPES.STAFF"
                :key="customField.id"
                :customField="customField"
                :info="info"
                @update:customField="$emit('update:customField', customField.id, $event)"
            />
        </template>
    </div>
</template>
<script>
import { CUSTOM_FIELDS_TYPES } from 'Dictionaries/customFields/customFieldsEnums';
import { defineAsyncComponent } from 'vue';
export default {
    components: {
        CustomFieldThird: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldThird.vue'),
        ),
        CustomFieldItem: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldItem.vue'),
        ),
        CustomFieldContact: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldContact.vue'),
        ),
        CustomFieldStaff: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldStaff.vue'),
        ),
        CustomFieldSelect: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldSelect.vue'),
        ),
        CustomFieldNumericWithUnit: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldNumericWithUnit.vue'),
        ),
        CustomFieldAmountWithCurrency: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldAmountWithCurrency.vue'),
        ),
        CustomFieldNumeric: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldNumeric.vue'),
        ),
        CustomFieldRichText: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldRichText.vue'),
        ),
        CustomFieldSimpleText: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldSimpleText.vue'),
        ),
        CustomFieldRadio: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldRadio.vue'),
        ),
        CustomFieldBoolean: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldBoolean.vue'),
        ),
        CustomFieldDate: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldDate.vue'),
        ),
        CustomFieldTime: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldTime.vue'),
        ),
        CustomFieldEmail: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldEmail.vue'),
        ),
        CustomFieldCheckBox: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldCheckBox.vue'),
        ),
        CustomFieldURL: defineAsyncComponent(
            () => import('vcomponents/common/customFields/CustomFieldURL.vue'),
        ),
    },
    props: {
        customFields: {
            type: Array,
            required: true,
        },
        shouldDisplayInfoOnPdf: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:customField'],
    data() {
        return {
            CUSTOM_FIELDS_TYPES,
        };
    },
    computed: {
        info() {
            return this.shouldDisplayInfoOnPdf ? this.$t.__('common.labels.show_on_pdf') : '';
        },
    },
};
</script>

<style>
.custom-fields-list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);
}
</style>
